/// <reference types="vite-plugin-svgr/client" />
import { useState } from 'react'
import { Box, Flex, UnstyledButton } from '@mantine/core'
import { MonthPicker as MantineMonthPicker } from '@mantine/dates'
import { useClickOutside } from '@mantine/hooks'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

import type { MonthPickerProps } from '@/components/MonthPicker/MonthPicker.types'
import { Text } from '@/components/Text/Text'

import ChevronIcon from '@/assets/icons/chevronDown.svg?react'

import classes from './MonthPicker.module.css'

export function MonthPicker({ month, onChange, ...props }: MonthPickerProps) {
  const [isOpened, setIsOpened] = useState<boolean>(false)
  const [selectedMonth, setSelectedMonth] = useState<Dayjs>(month)
  const [button, setButton] = useState<HTMLElement | null>(null)
  const [monthPicker, setMonthPicker] = useState<HTMLElement | null>(null)

  const handleMonthPickerToggle = () => setIsOpened((prev: boolean) => !prev)

  useClickOutside(() => setIsOpened(false), null, [button, monthPicker])

  return (
    <Box pos="relative">
      <UnstyledButton ref={setButton} onClick={handleMonthPickerToggle}>
        <Flex align="center" gap={12}>
          <Text className={classes.text} variant="body_1_semibold_green">
            {selectedMonth.format('MMM YYYY')}
          </Text>
          <ChevronIcon
            style={{
              transform: isOpened ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </Flex>
      </UnstyledButton>

      {isOpened && (
        <MantineMonthPicker
          ref={setMonthPicker}
          className={classes.monthPicker}
          classNames={{ monthsListControl: classes.customMonth }}
          defaultDate={selectedMonth.toDate()}
          maxDate={dayjs().toDate()}
          minDate={dayjs().subtract(1, 'year').toDate()}
          onChange={value => {
            if (value instanceof Date) {
              onChange(dayjs(value))
              setSelectedMonth(dayjs(value))
              setIsOpened(false)
            }
          }}
          value={selectedMonth.toDate()}
          {...props}
        />
      )}
    </Box>
  )
}
